import { useMemo } from 'react';
import type { DevFinancial } from '../types/financial';
import type { FinancialFilter } from '../types/financial-filters';

/**
 * Custom hook to filter financial records based on search query and filter criteria
 */
export const useFinancialFilters = (
  financials: DevFinancial[],
  searchQuery: string,
  filters: FinancialFilter
) => {
  return useMemo(() => {
    if (!financials) return [];

    return financials.filter(financial => {
      // Search query filter
      if (searchQuery) {
        const searchLower = searchQuery.toLowerCase();
        const matchesSearch = 
          (financial.fin_comm || '').toLowerCase().includes(searchLower) ||
          (financial.fin_supplier || '').toLowerCase().includes(searchLower) ||
          (financial.fin_desc || '').toLowerCase().includes(searchLower) ||
          (financial.fin_exp_proj || '').toLowerCase().includes(searchLower);
        
        if (!matchesSearch) return false;
      }

      // Community filter
      if (filters.community && financial.fin_comm !== filters.community) {
        return false;
      }

      // Supplier filter
      if (filters.supplier && financial.fin_supplier !== filters.supplier) {
        return false;
      }

      // Date range filter
      if (filters.dateFrom) {
        const financialDate = new Date(financial.fin_date);
        if (financialDate < filters.dateFrom) {
          return false;
        }
      }

      if (filters.dateTo) {
        const financialDate = new Date(financial.fin_date);
        if (financialDate > filters.dateTo) {
          return false;
        }
      }

      return true;
    });
  }, [financials, searchQuery, filters]);
};
